export const colors = {
    accents_gradient_start: "#FFD881",
    accents_grass: "#8DBD64",
    accents_lilac: "#A475DD",
    accents_salmon: "#FF9378",
    accents_sky: "#2C88D8",
    accents_sun: "#FFD881",
    accents_sunset: "#FF8A2D",
    black_10: "#0000001A",
    black_12: "#0714201F",
    black_30: "#0714204D",
    black_4: "#0D07000A",
    black_8: "#07142014",
    black_light: "#2D3A47",
    black_lighter: "#636A70",
    black_main: "#071420",
    chips_amethyst: "#7349A7",
    chips_amethyst_10: "#7349A71A",
    chips_azure: "#0F4B81",
    chips_azure_10: "#0F4B811A",
    chips_cherry: "#A82200",
    chips_cherry_10: "#A822001A",
    chips_ember: "#BD5500",
    chips_ember_10: "#BD55001A",
    chips_forest: "#477E35",
    chips_forest_10: "#477E351A",
    chips_neptune: "#2478C2",
    chips_neptune_10: "#2478C21A",
    chips_redwood: "#803900",
    chips_redwood_10: "#8039001A",
    chips_saffron: "#996900",
    chips_saffron_10: "#9969001A",
    chips_slate: "#636A70",
    chips_slate_10: "#636A701A",
    chips_tulip: "#DF280C",
    chips_tulip_10: "#DF280C1A",
    forest_12: "#477E351F",
    forest_30: "#477E354D",
    forest_4: "#477E350A",
    forest_50: "#477E3580",
    forest_8: "#477E3514",
    forest_dark: "#3B682C",
    forest_light: "#5DA545",
    forest_main: "#477E35",
    navy_12: "#0D27401F",
    navy_30: "#0D27404D",
    navy_4: "#0D27400A",
    navy_50: "#0D274080",
    navy_8: "#0D274014",
    navy_dark: "#071420",
    navy_light: "#0D375F",
    navy_main: "#0D2740",
    brand_blue_1: "#071420",
    brand_blue_3: "#0C2135",
    brand_blue_4: "#0D2740",
    brand_blue_5: "#0D2C4A",
    brand_blue_6: "#0E3254",
    brand_blue_7: "#0D375F",
    sunset_12: "#FF8A2D1F",
    sunset_30: "#FF8A2D4D",
    sunset_4: "#FF8A2D0A",
    sunset_50: "#FF8A2D80",
    sunset_8: "#FF8A2D14",
    sunset_dark: "#FF7406",
    sunset_light: "#FFA965",
    sunset_main: "#FF8A2D",
    tulip_12: "#DF280C1F",
    tulip_30: "#DF280C4D",
    tulip_4: "#DF280C0A",
    tulip_50: "#DF280C80",
    tulip_8: "#DF280C14",
    tulip_dark: "#BD220A",
    tulip_light: "#F44B32",
    tulip_main: "#DF280C",
    white_background: "#FAFAFA",
    white_main: "#FFFFFF",
    black: "#000",
    action_light: "#0000008a",
    blue_5: "#1D62AE0D",
    blue_10: "#1D62AE1A",
    blue_30: "#1D62AE4D",
    blue_50: "#1D62AE80",
    blue_main: "#1D62AE",
    accents_lilac_8: "#A475DD14",
    accents_sun_8: "#FFD88114",
    accents_sunset_12: "#ff8a2d1f",
    accents_sunset_25: "#ff8a2d40",
    accents_sunset_background: "#ffe5d0",
    orange_8: "#FF870014",
    chips_forest_8: "#477E3514",
    navy_30_opaque: "#b5bec5",
    navy_50_opaque: "#86939F",
    black_12_opaque: "#E1E2E4",
    white_background_gradient_start: "#FAFAFA00",
    clear_button_background: "#081245",
    clear_button_hover: "#0d1b57",
    record_emergency_hero_bg: "#fccfcc",
    record_primary_care_hero_bg: "#c7def9",
    record_specialist_hero_bg: "#d3d9f8",
    record_urgent_care_hero_bg: "#feeacf",
    record_annual_physical_hero_bg: "#cde3f4",
    record_rehabilitation_hero_bg: "#e3f2db",
    record_wellness_hero_bg: "#eed9c9",
    record_diagnostic_hero_bg: "#f0f0f1",
    record_immunization_hero_bg: "#ffffee",
    record_mental_health_hero_bg: "#f1e2ff",
    record_dental_hero_bg: "#cae7e5",
    record_vision_hero_bg: "#d7f0f5",
    record_ob_gyn_hero_bg: "#f5d9ed",
    record_emergency_icon_bg: "#F30E00",
    record_primary_care_icon_bg: "#0069E6",
    record_specialist_icon_bg: "#3951DE",
    record_urgent_care_icon_bg: "#FF970F",
    record_annual_physical_icon_bg: "#1C7ECC",
    record_rehabilitation_icon_bg: "#73BE4C",
    record_wellness_icon_bg: "#B45309",
    record_immunization_icon_bg: "#FFFFB4",
    record_mental_health_icon_bg: "#C07DFF",
    record_dental_icon_bg: "#0D9488",
    record_vision_icon_bg: "#4ABAD1",
    record_ob_gyn_icon_bg: "#D052AF",
    history_timeline_card_bg: "#FCFAF9",
    history_surface_bg: "#F4F4F4",
    history_hero_bg: "#F4F4F4",
    history_separator: "#BABCBF",
    history_separator_20: "#BABCBF33",
    history_separator_90: "#BABCBFE6",
    history_secondary_text: "#797E85",
    measurement_abnormal: "#C80600",
    measurement_normal: "#3F9C19",
    insight_card_bg: "#F8F6F3",
    insight_card_border: "#636A70",
    connection_banner_bg: "#F0F0F0",
    provider_icon_bg: "#E8E8E7",
    doc_pdf: "#FF321E",
    doc_pdf_bg: "#FF321E1A",
    doc_rtf: "#0043AA",
    doc_rtf_bg: "#0043AA1A",
    doc_html: "#D94C00",
    doc_html_bg: "#D94C001A",
    doc_txt: "#797E85",
    doc_txt_bg: "#797E8533",
    separator_main: "#BABCBF",
};
